const sortByAplhabet = (arr) => {
  return arr.sort((currValue, secondValue) => {
    return (currValue.Name > secondValue.Name) ? 1 : (currValue.Name < secondValue.Name) ? -1 : 0;
  });
};

export default sortByAplhabet;
